import { TagID } from '@/types/tag'

/**
 * 将URL参数中的tag名称转换为tag ID数组
 * @param tagsParam 逗号分隔的tag名称字符串，如 "Under The Mask,Christmas2025"
 * @param allTags 完整的tag列表数组
 * @returns tag ID数组
 */
export function parseTagsFromUrl(
  tagsParam: string | null,
  allTags: Array<{ id: TagID; tag: string }>
): TagID[] {
  if (!tagsParam) return []

  const tagNames = tagsParam
    .split(',')
    .map((name) => name.trim())
    .filter((name) => name.length > 0)

  return tagNames
    .map((name) => {
      // 从allTags中查找匹配的tag ID
      const found = allTags.find((t) => t.tag === name)
      return found?.id || null
    })
    .filter((id): id is TagID => id !== null)
}

/**
 * 将tag ID数组编码为URL参数格式
 * @param tagIds tag ID数组
 * @param allTags tag信息数组（用于反向查找tag名称）
 * @returns 逗号分隔的tag名称字符串
 * @example
 * // 用于生成分享链接或导出筛选条件
 * const tagIds = [1, 2, 3]
 * const urlParam = encodeTagsForUrl(tagIds, TagsSFW)
 * // 结果: "Action,Romance,Fantasy"
 */
export function encodeTagsForUrl(
  tagIds: TagID[],
  allTags: Array<{ id: TagID; tag: string }>
): string {
  return tagIds
    .map((id) => {
      const found = allTags.find((t) => t.id === id)
      return found?.tag || null
    })
    .filter((tag): tag is string => tag !== null)
    .join(',')
}
